import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,FormControl, Validators } from '@angular/forms';
import {Router, ActivatedRoute } from "@angular/router";
import { ApiService } from "../../services/api.service";
import { NgxSpinnerService } from "ngx-spinner";
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ConfirmedValidator } from '../../services/confirmed.validator';
import { environment} from '../../../environments/environment';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

  forgetPasswordForm:any;
  submitted = false;
  password:string='';
  status:any='';
  re_password:string=''; closeResult: any = '';
 
  userId:any='';suucessMsgForget:any='';
   private BASE_URL: string = environment.BASEURL;
  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  constructor(private auth:ApiService,
    private route: ActivatedRoute,
    
    private router: Router,private spinner: NgxSpinnerService,private formbuilder:FormBuilder,private modalService: NgbModal) {

      this.route.queryParams.subscribe(queryParams => {
        this.status = queryParams['status'];
      });
      if(this.status == 2){
        this.BASE_URL = environment.BASEURL+'/#/admin-login/';
        //this.BASE_URL = environment.BASEURL+'/admin-login/';
      }
    this.forgetPasswordForm = this.formbuilder.group({
      email: new FormControl('', [Validators.required, Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
        link: new FormControl(this.BASE_URL),
    })
  }

  ngOnInit(): void {
    
  }
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  get f() { return this.forgetPasswordForm.controls; }
  forgetPass(form:any){
    this.submitted = true;
     //stop here if form is invalid
     if (this.forgetPasswordForm.invalid) { return; }
     this.spinner.show();
     this.auth.forgetPassword(this.forgetPasswordForm.value).subscribe(
       data => {
          if(data.status == 200){
            this.spinner.hide();
            this.suucessMsgForget = 'Your password has been sent to the registered Email ID';
            document.getElementById('successMsg')?.click();
            if(this.status == 1){
              this.router.navigateByUrl('/'); 
            }else if(this.status == 2){
              this.router.navigateByUrl('/admin-login'); 
            }
            
          } else if(data.status == 400){
            this.spinner.hide();
            this.errorInfo.isError = true;
            this.errorInfo.errorMsg = data.message;
          }
       },
       error => {
        this.spinner.hide();
        //alert(error);
      });  
  }

}
